<div class="space-y-6">
  <app-page-header
    [backTo]="['/permissions/resources', resource()?.id]"
    backLabel="Retour à la fiche"
    title="Modifier la resource"
  />

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      (retry)="fetch()"
    />
  } @else if (resource(); as r) {
    <app-resource-form
      mode="edit"
      [resource]="r"
      [submitting]="submitting()"
      [serverError]="serverError()"
      (save)="onSave($event)"
      (cancel)="onCancel()"
    />
  }
</div>
